<template>
  <div>
    <div
      v-if="title"
      class="subtitle-1 font-weight-bold"
    >
      {{ title }}
    </div>
    <v-progress-circular
      v-if="saving"
      :size="125"
      :width="4"
      indeterminate
      color="primary"
      class="mx-auto"
    />
    <v-img
      v-else-if="url"
      :height="height"
      :src="url"
      contain
      class="cursor-pointer"
      @click="$refs.hiddenUpload.click()"
    />
    <v-card
      v-else
      class="full-height"
    >
      <v-card-text class="full-height text-center">
        <v-icon
          large
          @click="$refs.hiddenUpload.click()"
        >
          add
        </v-icon>
      </v-card-text>
    </v-card>
    <input
      ref="hiddenUpload"
      type="file"
      style="display: none"
      @change="$emit('save', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    url: { type: String, default: '' },
    height: { type: String, default: '' },
    saving: { type: Boolean, default: false }
  }
};
</script>
